"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastWrapperPosition = exports.ToastType = void 0;
var ToastType;
exports.ToastType = ToastType;

(function (ToastType) {
  ToastType["CAUTION"] = "caution";
  ToastType["INFO"] = "info";
  ToastType["SUCCESS"] = "success";
  ToastType["WARNING"] = "warning";
})(ToastType || (exports.ToastType = ToastType = {}));

var ToastWrapperPosition;
exports.ToastWrapperPosition = ToastWrapperPosition;

(function (ToastWrapperPosition) {
  ToastWrapperPosition["TOP"] = "top";
  ToastWrapperPosition["TOP_LEFT"] = "top-left";
  ToastWrapperPosition["TOP_RIGHT"] = "top-right";
  ToastWrapperPosition["BOTTOM"] = "bottom";
  ToastWrapperPosition["BOTTOM_LEFT"] = "bottom-left";
  ToastWrapperPosition["BOTTOM_RIGHT"] = "bottom-right";
})(ToastWrapperPosition || (exports.ToastWrapperPosition = ToastWrapperPosition = {}));